import React, { memo } from 'react';
import WalkthroughOverlay from './WalkthroughOverlay';
import { useShowWalkthroughV6 } from './hooks/useShowWalkthroughV6';
const WalkthroughHeaderOverlay = ({ v6 }) => {
    const showWalkthroughV6 = useShowWalkthroughV6();
    if (v6 && !showWalkthroughV6) {
        return null;
    }
    return <WalkthroughOverlay />;
};
export default memo(WalkthroughHeaderOverlay);
